import { render, staticRenderFns } from "./AddContractModal.vue?vue&type=template&id=c974fc16"
import script from "./AddContractModal.vue?vue&type=script&lang=js"
export * from "./AddContractModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports